// extracted by mini-css-extract-plugin
export default {"container":"ClassPresentationSubmission_container__QCYhi"};